import { render, staticRenderFns } from "./ServiciosExternos.vue?vue&type=template&id=408a2046"
import script from "./ServiciosExternos.vue?vue&type=script&lang=js"
export * from "./ServiciosExternos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports